import React, { Component } from "react";
import { ROUTES } from "const";
import { Row, Col } from "design-react-kit";
import ReactHtmlParser from "react-html-parser";
import "./HomeCourses.css";

/** OLD BOXES 
 * 
 * {
    link: ROUTES.FORM_60CFU,
    image: `/img/courses/new/30cfu_34_24.jpg`,
    title: "Corsi Abilitanti 30 CFU a.a. 25/26",
    subTitle: "per docenti abilitati o con Sostegno<br/><br/>",
    highlights: "Corsi da € 1500.",
  },{
    link: `/corso-online/CSU24CFU`,
    image: `/img/courses/new/24cfu.jpg`,
    title: "Corsi Singoli 24CFU",
    subTitle: "24CFU Corsi per l'insegnamento",
    highlights: "Iscrizioni chiuse",
  },
  {
    link: `/corso-online/MUMC24`,
    image: `/img/courses/new/master-24cfu2.jpeg`,
    title: "Master 24CFU",
    subTitle: "Comprensivo dei 24CFU per l'insegnamento",
    highlights: "Iscrizioni chiuse",
  },
  {
    link: ROUTES.FORM_60CFU,
    image: `/img/courses/new/30_60cfu.jpg`,
    title: "Corsi Abilitanti 30 CFU - A.A. 23/24",
    subTitle: 'Solo per docenti già abilitati su materia o specializzati sul sostegno',
    highlights: "ISCRIZIONE APERTE <br/> A partire da € 1500",
  },{
    link: `${ROUTES.COURSE_BROWSE_60CFU}/unitelma`,
    image: `/img/courses/new/60cfu.jpg`,
    title: "   <br/>Oltre 1200 posti Corsi Abilitanti con Unitelma Sapienza",
    subTitle: '',
  }{
    link: `${ROUTES.COURSE_BROWSE_60CFU}/reggio`,
    image: `/img/courses/new/30_60cfu.jpg`,
    title: "<br/>Autorizzati altri 1477 posti nei corsi Abilitanti!",
    subTitle: 'Solo con noi in tutta Italia!<br/><b><span style="color:red">Graduatorie disponibili</span></b>',
  }, 
   {
    link: `${ROUTES.PAGE_TFAINDIRE}/`,
    image: `/img/courses/new/tfa_indire.jpg`,
    title: "INDIRE",
    subTitle: '<b>Sostegno con titolo Estero</b><br/><b>Sostegno con 3 anni di servizio</b><br/><b>Esami in tutte le Regioni!</b>',
  },
   {
     link: ROUTES.ENROLL_TFA_IX_CICLO_RISERVATO,
     image: `/img/courses/banner_u24cfu.webp`,
     title: "TFA Sostegno 2024",
     subTitle: 'Solo riservisti',
     highlights: "(con 3 anni di servizio su sostegno)",
   },{
    link: `${ROUTES.COURSE_BROWSE}/PLU`,
    image: `/img/courses/new/plu.jpg`,
    title: "Diplomi di perfezionamento post laurea",
    subTitle: "1500 ore e 60 CFU",
    highlights: "Da € 389",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/PDU`,
    image: `/img/courses/new/pd.jpg`,
    title: "Diplomi di perfezionamento post diploma",
    subTitle: "1500 ore e 60 CFU",
    highlights: "Da € 389",
  },{
     link: `${ROUTES.PAGE_CORSIDILAUREA}`,
     image: `/img/courses/new/corsi-di-laurea.jpg`,
     title: "Corsi di Laurea",
     subTitle:
       "<br/>Lauree VERE per un futuro lavorativo REALE: da Scienze Infermieristiche a Medicina!",
   },{
    image: `/img/courses/new/nuovi_master.jpg`,
    title: "A breve Master per:",
    subTitle: "&checkmark; A-26 Matematica<br/> &checkmark; A-27 Matematica e Fisica<br/> &checkmark; A-28 Matematica e Scienze<br/><b>Conseguibili da Febbraio 2024 (entro l'aggiornamento Grad. Istituto)</b>",
    highlights: "",
  },{
    link: `${ROUTES.PAGE_MASTERMUPAMSLU}`,
    image: `/img/courses/new/mupabox.jpg`,
    title: "Master per ",
    subTitle: "",
    highlights: " - Pubblica Amministrazione <br/>- Forze Armate",
  },{
     link: "https://www.asuniver.it/corso-di-sostegno-allestero/",
     image: `/img/courses/new/sostegno_spagna.jpg`,
     title: "Corso di Sostegno all’estero",
   },
 */
const COURSE_BOXES_ABILITATION = [
  /* {
     //link: `${ROUTES.COURSE_BROWSE_PERCORSI_ABILITANTI}/reggio`,
     image: `/img/courses/new/sostegno_triennalisti.jpg`,
     title: "<br/>Università per stranieri “Dante Alighieri” di R.C.",
     subTitle: 'Percorsi Abilitanti 60-30 CFU a.a. 25/26',
     highlights: "Iscrizioni chiuse",
   },
     {
    //link: `${ROUTES.COURSE_BROWSE_PERCORSI_ABILITANTI}/unicamillus`,
    image: `/img/courses/new/corsiabilitanti60cfu.jpg`,
    title: "<br/>Università Unicamillus",
    subTitle: 'Percorsi Abilitanti 60-30-36 CFU a.a. 25/26',
    highlights: "Iscrizioni chiuse",
  },
   {
     //link: `${ROUTES.COURSE_BROWSE_PERCORSI_ABILITANTI}/unitelma`,
     image: `/img/courses/new/tfa_indire.jpg`,
     title: "<br/>Università UnitelmaSapienza",
     subTitle: 'Percorsi Abilitanti 60-30 CFU a.a. 25/26',
     highlights: "Iscrizioni chiuse",
   },
   {
    link: ROUTES.FORM_TFA_SOSTEGNO_TRIENNALISTI,
    image: `/img/courses/new/sostegno_triennalisti.jpg`,
    title: "Percorsi INDIRE<br/>Corsi per docenti con 3 anni sul sostegno",
    subTitle: '',
    highlights: 'Iscrizioni aperte <br/> Scadenza: 19 Maggio 2026 ore 15:00',
  },
  {
    link: ROUTES.FORM_TFA_SOSTEGNO_ESTERO,
    image: `/img/courses/new/sostegno_estero.jpg`,
    title: "Percorsi INDIRE<br/>Corsi per docenti con abilitazione estera",
    subTitle: '',
    highlights: 'Iscrizioni aperte <br/> Scadenza: 19 Maggio 2026 ore 15:00',
  },
    {
    link: `${ROUTES.PAGE_TFAINDIREESTEROTRIENNALISTI}`,
    image: `/img/courses/new/sostegno_triennalisti.jpg`,
    title: "Percorsi INDIRE<br/>con 3 anni sul sostegno<br/>con abilitazione estera",
    subTitle: "",
    highlights: "Scadenza: 19 Maggio 2026 ore 15:00",
  },*/
];

const COURSE_BOXES = [
  {
    link: `${ROUTES.COURSE_BROWSE}/MU`,
    image: `/img/courses/new/mu.jpg`,
    title: "Master di I livello",
    subTitle: "1500 ore e 60 CFU",
    highlights: "Da € 440",
  },
  {
    link: `https://www.formazionedocenti.it/page/corsi-abilitanti-60-cfu-2026`,
    image: `/img/courses/new/24cfu.jpg`,
    title: "Percorsi abilitanti 60 e 30 CFU",
    subTitle: 'a.a. 2026/2027',
    highlights: 'Approvati dal Ministero',
  },
  {
    link: ROUTES.COURSE_SSD_BROWSE,
    image: `/img/courses/new/mr.jpg`,
    title: "Corsi Singoli e Master",
    subTitle:
      "A11, A18, A28, A21, A26, A46... <br/><b>Nuovi Master: A26, A27, A28</b>",
    highlights: "Da € 440",
  },

  {
    link: `${ROUTES.COURSE_BROWSE}/corsi-singoli-universitari`,
    image: `/img/courses/new/ucsu.jpeg`,
    title: "Corsi Singoli Universitari",
    subTitle: "",
    highlights: "",
  },
  {
    link: `${ROUTES.PAGE_PERFEZIONAMENTOPDUPLU}/`,
    image: `/img/courses/new/plu.jpg`,
    title: "Diplomi di perfezionamento",
    subTitle: "1500 ore e 60 CFU",
    highlights: "Da € 389",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/UCLIL`,
    image: `/img/courses/new/clil.jpg`,
    title: "Perfezionamento CLIL",
    subTitle: "1500 ore e 60 CFU",
    highlights: "A soli € 498",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/MDU`,
    image: `/img/courses/new/mdu.jpg`,
    title: "Master di II livello",
    subTitle: "1500 ore e 60 CFU",
    highlights: "",
  },
  {
    link: `${ROUTES.PAGE_MASTERMUPAMSLU}`,
    image: `/img/courses/new/mupabox.jpg`,
    title: "Master per ",
    subTitle: "",
    highlights: " - Pubblica Amministrazione <br/>- Forze Armate",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/BU-I`,
    image: `/img/courses/new/bu-i.jpg`,
    title: "Diplomi di perfezionamento biennale",
    // subTitle: "1500 ore e 60 CFU per ogni annualità",
    highlights:
      "Docenti di ruolo: punti 5 nei trasferimenti <br/>Precari: punti 2 (oltre ai 3 corsi annuali)",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/ENG`,
    image: `/img/courses/new/eng.jpg`,
    title: "Inglese B2-C1",
    subTitle: "Pearson Education Limited",
    highlights: "",
  },
  {
    link: `${ROUTES.ADESIONI_60CFU}`,
    image: `/img/courses/banner_tfa_01.jpg`,
    title: "Percorsi Abilitanti per Docenti 30, 36, 60 CFU",
    subTitle: "A.A. 2026/2027",
    highlights: "",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/DIGCOMP`,
    image: `/img/courses/new/accredia.png`,
    title: "Certificazione DIGCOMP2.2 e Certificazione DigCompEdu",
    subTitle: "accreditate Accredia ",
    highlights: "",
  },
    {
    link: `https://www.formazionedocenti.it/page/tfa-sostegno-xi-ciclo-unicamillus`,
    image: `/img/courses/new/sostegno_estero.jpg`,
    title: "TFA SOSTEGNO  -  ITALIANO",
    subTitle: 'XI Ciclo - a.a. 25/26 Autorizzato dal MUR',
    highlights: 'Iscrizioni chiuse',
  },
];

/** OLD BOXES SMALL 
 *  /* {
     link: '/corso-online-mnemosine/TFA_IX_CICLO_ORDINARIO',
     image: `/img/courses/banner_tfa_02.jpg`,
     title: "TFA Sostegno Ordinario 2024",
   },
   {
    link: ROUTES.ENROLL_TFA_IX_CICLO + '/TFA_IX_CICLO_RISERVATO',
    image: `/img/courses/banner_tfa_01.jpg`,
    title: "TFA Sostegno 2024",
    subTitle: 'Solo riservisti',
    highlights: "(con 3 anni di servizio su sostegno)",
  },
  {
    link: "/corso-online-mnemosine/TFA_IX_CICLO_SOPRANNUMERARI_IDONEI",
    image: `/img/courses/banner_tfa_01.jpg`,
    title: "TFA Sostegno 2024",
    subTitle: 'Solo per soprannumerari',
  },
  {
    link: ROUTES.ENROLL_TFA_IX_CICLO + '/TFA_IX_CICLO_RISERVATO',
    image: `/img/courses/banner_tfa_01.jpg`,
    title: "TFA Sostegno 2024",
    subTitle: 'Solo riservisti',
    highlights: "(con 3 anni di servizio su sostegno)",
  },
  {
    link: "/corso-online-mnemosine/TFA_IX_CICLO_SOPRANNUMERARI_IDONEI",
    image: `/img/courses/banner_tfa_01.jpg`,
    title: "TFA Sostegno 2024",
    subTitle: 'Solo per soprannumerari',
  },{
    link: `/corso-online-mnemosine/RCPFU5CFU`,
    image: `/img/courses/new/5cfu.png`,
    title: "Percorso di Formazione 5 CFU",
    subTitle: "Per docenti vincitori di Concorso - Esami in PRESENZA",
    highlights: "",
  },{
    link: '/corso-online-mnemosine/ADESIONI_SOSTEGNO',
    image: `/img/courses/new/adesioni_sostegno.jpg`,
    title: "Corso per Docenti",
    subTitle: "con sostegno conseguito all'estero e con 3 anni di servizio sul sostegno ",
  },
  {
    link: '/corso-online-mnemosine/DIGCOMP2.2',
    image: `/img/courses/new/accredia_banner.png`,
    title: "Certificazione internazionale di alfabetizzazione digitale (CIAD)",
    subTitle: "Obbligatoria per accesso Graduatorie ATA  - ISCRIZIONI CHIUSE"
  },
*/
const COURSE_BOXES_SMALL = [
  {
    link: `${ROUTES.COURSE_BROWSE}/INFO`,
    image: `/img/courses/new/info.jpg`,
    title: "Certificazioni Informatiche",
  },
  {
    link: `${ROUTES.COURSE_BROWSE}/ATA`,
    image: `/img/courses/new/ata.jpg`,
    title: "Dattilografia e ICDL IT-Security",
  },
  {
    link: `/corso-online/ABA`,
    image: `/img/courses/new/aba-v2.jpg`,
    title: "ABA",
    subTitle: "Applied Behavior Analysis",
  },
  {
    link: `/corsi-mnemosine/FC`,
    image: `/img/courses/new/formazione-continua-v2.jpg`,
    title: "Formazione continua",
    subTitle: "Valorizza il buono scuola con i nostri corsi",
  },
  {
    link: `https://www.formazionedocenti.it/come-generare-il-bonus-scuola-per-i-corsi-mnemosine`,
    image: `/img/home/carta-docenti-v3.jpg`,
    title: "Carta docenti",
    subTitle: "Come generare il bonus con Mnemosine",
    highlights: "",
  },
  {
    link: `https://www.formazionedocenti.it/corso-online-mnemosine/INFOG228`,
    image: `/img/courses/intelligenza-artificiale.jpg`,
    title: "L'Intelligenza Artificiale Generativa nella didattica",
    subTitle: "Una guida sugli strumenti online e il prompt engineer",
    highlights: "",
  },
];

export class HomeCourses extends Component {
  componentDidMount() { }

  /** OLD SECTIONS 
   *  <HomeCoursesGrid courses={FEATURED_HOME_COURSES} />
        <SlideMoreCourses courses={MORE_HOME_COURSES} /> 
   * <section className="programmes">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <Row>
                <a href="https://www.asuniver.it/corso-di-sostegno-allestero/" rel="noopener noreferrer"  target="_blank">
                  <img
                    className="w-100"
                    src="/img/home/sostegno_banner.jpg"
                    alt="Corso di Sostegno all'estero"
                  />
                </a>
              </Row>
            </div>
          </div>
    </section>
     <section className="programmes">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <Row>
                <a href="../corsi-mnemosine/UCSU" rel="noopener noreferrer" target="_blank">
                  <img
                    className="w-100"
                    src="/img/home/banner_ucsu_home.png"
                    alt="Con noi esami in presenza"
                  />
                </a>

              </Row>
            </div>
          </div>
  </section>
   */
  render() {
    return (
      <>        
        <section className="programmes">

          <Row>
            {COURSE_BOXES_ABILITATION.map((course, i) => (
              <Col xs={12} sm={6} md={4} key={`course-a-${i}`}>
                <div className="swiper-slide">
                  <div className="programme-card">
                    <a className="programme-card__link" href={course.link}>
                      <div className="programme-card__header">
                        <img
                          className="programme-card__img"
                          alt={course.title}
                          src={course.image}
                        />
                      </div>
                      <div className="programme-card__body">
                        <h4 className="programme-card__title">
                          {course.title && course.title.length > 0 && (
                            <>
                              {ReactHtmlParser(course.title)} <br />
                            </>
                          )}
                          {course.subTitle && (
                            <>
                              <div
                                className="small mypt-2"
                                dangerouslySetInnerHTML={{
                                  __html: course.subTitle,
                                }}
                              />
                            </>
                          )}
                        </h4>
                        {course.highlights && (
                          <h6
                            className="text-red  text-highlights"
                            dangerouslySetInnerHTML={{
                              __html: course.highlights,
                            }}
                          />
                        )}
                      </div>
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

        </section>
        <section className="programmes">
          <Row>
            <Col xs={12}>
              <div className="swiper-slide">
                <div className="programme-card">
                  <a href={ROUTES.FORM_60CFU} className="programme-card__link">
                    <div className="programme-card__body text-center">
                      <h4 className="mt-4">
                        Corsi Abilitanti 30 CFU- ONLINE 100% per Docenti abilitati o con Sostegno<br />
                        <span className="text-red text-hightlights span-price"> Corsi da € 1.500 </span> Scadenza 5 Novembre
                      </h4>
                    </div>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </section >
        <section className="programmes">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <Row>
                {COURSE_BOXES.map((course, i) => (
                  <Col xs={12} sm={6} md={4} lg={4} key={`course-${i}`}>
                    <div className="swiper-slide">
                      <div className="programme-card">
                        <a className="programme-card__link" href={course.link}>
                          <div className="programme-card__header">
                            <img
                              className="programme-card__img"
                              alt={course.title}
                              src={course.image}
                            />
                          </div>
                          <div className="programme-card__body">
                            <h4 className="programme-card__title">
                              {course.title && course.title.length > 0 && (
                                <>
                                  {ReactHtmlParser(course.title)} <br />
                                </>
                              )}
                              {course.subTitle && (
                                <>
                                  {/* <span className="small">
                                    {course.subTitle}
                                  </span> */}
                                  <div
                                    className="small mypt-2"
                                    dangerouslySetInnerHTML={{
                                      __html: course.subTitle,
                                    }}
                                  />
                                </>
                              )}
                            </h4>
                            {course.highlights && (
                              <h6
                                className="text-red  text-highlights"
                                dangerouslySetInnerHTML={{
                                  __html: course.highlights,
                                }}
                              />
                            )}
                          </div>
                        </a>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </section>
        <section className="">
          <Row>
            <Col xs={12}>             
                  <a href='mnemosine-social/impegno-solidarieta' >                   
                      <img
                        className="w-100"
                        src="/img/home/mnemosine_per_il_sociale_wide.png"
                        alt="Progetti umatari e di solidarietà"                       
                      />                    
                  </a>
            </Col>
          </Row>
        </section >
        <section className="programmes">
          <h2 className="programmes-title">Altri Corsi</h2>
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <Row className="w-100">
                {COURSE_BOXES_SMALL.map((course, i) => (
                  <Col xs={12} sm={6} md={4} lg={4} key={`course-${i}`}>
                    <div className="swiper-slide">
                      <div className="programme-card">
                        <a className="programme-card__link" href={course.link}>
                          <div className="programme-card__header">
                            <img
                              className="programme-card__img"
                              alt={course.title}
                              src={course.image}
                            />
                          </div>
                          <div className="programme-card__body">
                            <h4 className="programme-card__title">
                              {course.title}
                              {course.subTitle && (
                                <div className="small mt-2">
                                  {course.subTitle}
                                </div>
                              )}
                            </h4>
                            {course.highlights && (
                              <h6
                                className="text-highlights"
                                dangerouslySetInnerHTML={{
                                  __html: course.highlights,
                                }}
                              />
                            )}
                          </div>
                        </a>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </section>
        <section className="secondary-banner-home">
          <div className="programmes-single__wrapper ">
            <Row>
              <Col md={12}>
                <a className="wrapper-link" href="../page/al-fine-di-tutelare-i-corsisti-Mnemosine" rel="noopener noreferrer" target="_blank">
                  <h2 className="text-white">
                    Al fine di tutelare i corsisti Mnemosine (e non solo) è interessante sapere che...
                  </h2>
                </a>
              </Col>
            </Row>
          </div>
        </section>
      </>
    );
  }
}
